// src/services/customer_fonts.js

import apiClient from './api';

/**
 * The company's licensed fonts, scoped by the auth token.
 *
 * Rows: { fontId, customer_id, font_key, font_label, zpl_id, sort_order }
 *
**/
export async function fetchCustomerFonts() {
  const response = await apiClient.get('/customer-fonts');
  return Array.isArray(response.data) ? response.data : [];
}